;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller('ModalTagAttacksCtrl', ModalTagAttacksCtrl)

  function ModalTagAttacksCtrl(
    $scope,
    $uibModalInstance,
    TagFactory,
    TagService,
    ErrorService,
    attacks,
    title
  ) {
    'ngInject'

    var attacksId = _.map(attacks, 'id'),
      originalTags = []

    angular.extend($scope, {
      attacks: attacks,
      title: title,
      has_tags: false,
      bulk_operation: false,
      taggingLabel: TagService.getTaggingLabel(),
      model: {
        tags: []
      }
    })

    angular.extend($scope, {
      ok: save,
      cancel: cancel,
      hasAvailableTags: hasAvailableTags,
      onTaggingSelect: TagService.onTaggingSelect.bind($scope, 'model.tags')
    })

    function init() {
      TagFactory.getAttacksTags().then(function (response) {
        $scope.availableTags = response.data.tags
      }, _processError)

      TagFactory.getAttacksTagsBulk(attacksId).then(function (response) {
        if (response.data.tags) {
          originalTags = response.data.tags
          $scope.model.tags = response.data.tags
          $scope.has_tags = originalTags.length > 0
          $scope.bulk_operation = $scope.has_tags && attacksId.length > 1
        }
      }, _processError)
    }

    function save() {
      TagFactory.tagAttacksBulk(_tagRequest()).then(function (response) {
        var data = response.data
        $uibModalInstance.close(data.messages[0])
      }, _processError)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function _processError(response) {
      ErrorService.processError(response)
      $uibModalInstance.close()
    }

    function _tagRequest() {
      var tagsRemove = _.difference(originalTags, $scope.model.tags)
      return {
        attacks_id: attacksId,
        tags: $scope.model.tags,
        tags_remove: tagsRemove
      }
    }

    function hasAvailableTags() {
      return (
        !$scope.has_tags &&
        $scope.model.tags &&
        $scope.model.tags.length == 0 &&
        $scope.availableTags &&
        $scope.availableTags.length == 0
      )
    }

    init()
  }
})()
